module.exports = __webpack_public_path__ + "static/media/IMG_0247.17fe5c27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/IMG_0247.jpg
// module id = 472
// module chunks = 0